// The body of the new-user registration POST (RB-326, legal-brand-4): the one place it is built, so the version of the
// User Agreement the checkbox named travels with the acceptance. The API keeps the boolean today; the column for the version
// is Nikunj's change (RB-326). Tested in src/test/testCases/Pages/NewUserRegistration.test.tsx.
import { LEGAL } from '../../config/legal';

export interface RegistrationForm {
    first_name?: string;
    last_name?: string;
    email_address?: string;
    contact_number?: string;
    user_agreement_checkbox?: boolean;
    re_captcha?: string;
}

export function registrationPayload(form: RegistrationForm, agentRoleId: number | null | undefined, licensesHeld: string[]) {
    return {
        first_name: form?.first_name,
        last_name: form?.last_name,
        email_address: form?.email_address,
        contact_number: form?.contact_number,
        user_role_id: agentRoleId,
        user_agreement_checkbox: form?.user_agreement_checkbox,
        user_agreement_version: LEGAL.agreementVersion,
        re_captcha: form?.re_captcha,
        user_licenses_held: licensesHeld,
        created_by_admin_flag: false,
        admin_user_id: null,
    };
}
